<div class="staff-overview-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">People Operations</p>
      <h2>Staff Overview</h2>
      <p class="subtitle">Track workforce readiness, approval queues, department coverage, and message load from one command desk.</p>
    </div>
    <button mat-stroked-button (click)="loadOverview()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card primary">
      <span>Total Staff</span>
      <strong>{{ staff.length }}</strong>
      <small>Current people directory size</small>
    </article>
    <article class="stat-card success">
      <span>Active Staff</span>
      <strong>{{ activeStaffCount }}</strong>
      <small>Available and active in the system</small>
    </article>
    <article class="stat-card warning">
      <span>Pending Requests</span>
      <strong>{{ pendingRequests.length }}</strong>
      <small>Items waiting for approval</small>
    </article>
    <article class="stat-card accent">
      <span>Unread Inbox</span>
      <strong>{{ unreadInboxCount }}</strong>
      <small>Unread internal staff messages</small>
    </article>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Department Coverage</h3>
        <span>Top departments</span>
      </div>
      <div class="metric-list" *ngIf="departmentBreakdown.length; else noDepartments">
        <div class="metric-row" *ngFor="let row of departmentBreakdown">
          <div>
            <strong>{{ row.label }}</strong>
            <small>{{ row.value }} staff</small>
          </div>
          <div class="meter">
            <div class="fill" [style.width.%]="staff.length ? (row.value / staff.length) * 100 : 0"></div>
          </div>
        </div>
      </div>
    </article>

    <article class="panel">
      <div class="panel-head">
        <h3>Approval Queue</h3>
        <span>Latest requests</span>
      </div>
      <div class="request-list" *ngIf="recentRequests.length; else noRequests">
        <div class="request-item" *ngFor="let row of recentRequests">
          <div>
            <strong>{{ row.title || row.requestType }}</strong>
            <p>{{ row.staffName || row.requestedByName || 'Staff request' }}</p>
          </div>
          <div class="request-meta">
            <span>{{ row.requestType || 'Request' }}</span>
            <small>{{ row.requestedAt | date:'mediumDate' }}</small>
          </div>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Role Mix</h3>
        <span>Top positions</span>
      </div>
      <div class="tag-cloud">
        <span class="tag" *ngFor="let row of positionBreakdown">{{ row.label }} · {{ row.value }}</span>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Directory Spotlight</h3>
        <span>{{ inactiveStaffCount }} inactive</span>
      </div>
      <div class="people-list" *ngIf="spotlightStaff.length; else noStaff">
        <div class="person-row" *ngFor="let row of spotlightStaff">
          <div class="avatar">{{ (row.fullName || '?').charAt(0) }}</div>
          <div>
            <strong>{{ row.fullName }}</strong>
            <small>{{ row.department || 'Unassigned department' }} · {{ row.position || 'No position' }}</small>
          </div>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noDepartments>
  <p class="muted">No department breakdown is available yet.</p>
</ng-template>

<ng-template #noRequests>
  <p class="muted">There are no pending staff requests right now.</p>
</ng-template>

<ng-template #noStaff>
  <p class="muted">No staff records found.</p>
</ng-template>
